import { aboutInfo } from '@/mocks/site';

export default function AboutBrand() {
  const { brand } = aboutInfo;

  return (
    <section className="mb-16">
      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
        品牌介绍
      </h2>
      <div className="bg-background-100 rounded-lg p-6 md:p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-global-line text-background-50 text-xl"></i>
          </div>
          <div>
            <strong className="font-heading text-lg text-foreground-900">{brand.title}</strong>
            <p className="text-foreground-500 text-xs">{brand.subtitle}</p>
          </div>
        </div>

        <p className="text-foreground-700 text-sm leading-relaxed mb-6">
          {brand.intro}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div className="bg-background-50 rounded-lg p-5">
            <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-3 flex items-center gap-2">
              <i className="ri-focus-2-line text-primary-600"></i>
              平台使命
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">{brand.mission}</p>
          </div>
          <div className="bg-background-50 rounded-lg p-5">
            <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-3 flex items-center gap-2">
              <i className="ri-eye-line text-accent-600"></i>
              平台愿景
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">{brand.vision}</p>
          </div>
        </div>

        <div>
          <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-3">核心价值观</h3>
          <div className="flex flex-wrap gap-3">
            {brand.values.map((v) => (
              <span key={v} className="text-sm bg-background-50 text-foreground-700 px-4 py-2 rounded-lg border border-background-200/70 whitespace-nowrap">
                {v}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}